import React, { useRef } from "react";
import { ClipIcon } from "../Icons";
import { GenAIButton } from "../GenAIButton";
import { Tooltip } from "@bolt/components";

type FileUploadProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  acceptedFiles: string[];
  disabled: boolean;
  text: string;
  tooltipText: string;
};
export const FileUpload = ({ onChange, acceptedFiles, disabled, text, tooltipText }: FileUploadProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(event);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  const onClickHandler = () => {
    inputRef.current?.click();
  };

  return (
    <Tooltip color="inverted" content={tooltipText}>
      <span className="tooltip-handler">
        <GenAIButton
          icon={<ClipIcon />}
          onClick={onClickHandler}
          disabled={disabled}
          dataTestId={"gen-ai-button-file-upload"}
        >
          {text}
          <input
            disabled={disabled}
            type="file"
            onChange={onChangeHandler}
            hidden
            accept={[...acceptedFiles].join(",")}
            ref={inputRef}
            data-testid={"file-input"}
          />
        </GenAIButton>
      </span>
    </Tooltip>
  );
};
